<div *ngIf="loader.loading$ | async"
    class="fixed inset-0 bg-black opacity-70 flex flex-col items-center justify-center z-[9999]">

    <div class="relative w-20 h-20 mb-6">
        <div class="absolute w-6 h-6 bg-[#0078D7] animate-square1"></div>
        <div class="absolute w-6 h-6 bg-[#0078D7] animate-square2"></div>
        <div class="absolute w-6 h-6 bg-[#0078D7] animate-square3"></div>
        <div class="absolute w-6 h-6 bg-[#0078D7] animate-square4"></div>
    </div>

    <div class="text-white text-xl font-semibold animate-pulse">
        Please Wait…
    </div>

    <div class="w-64 h-2 mt-6 bg-gray-600 relative overflow-hidden">
        <div class="absolute inset-y-0 w-1/3 bg-[#0078D7] animate-progress"></div>
    </div>
</div>